import { render, staticRenderFns } from "./TwitterFeedHome.vue?vue&type=template&id=19476496"
import script from "./TwitterFeedHome.vue?vue&type=script&lang=js"
export * from "./TwitterFeedHome.vue?vue&type=script&lang=js"
import style0 from "./TwitterFeedHome.vue?vue&type=style&index=0&id=19476496&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports